// Vite (vite.config.js) uses this file to import packages and then compile them into a minified JS file (app.js).
import 'bootstrap';
import $ from 'jquery';

window.$ = $;
window.jQuery = $;